// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__9rogA","list":"Footer_list__bip1S","link":"Footer_link__vnro3"};